import styled from "styled-components";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { Tabs } from "@/pages/Settings";
import { RootState } from "@/utils/store";
import Button from "../Button";
import Text from "../Text";

const Box = styled.div`
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  padding: 20px 16px 17px;
  position: sticky;
  left: 16px;
  bottom: 24px;
  width: calc(100% - 32px);
`;

const Content = styled(Text)`
  line-height: 16px;
  margin-top: 6px;
  margin-bottom: 16px;
`;

const Heading = styled(Text)`
  display: flex;
  align-items: center;
  svg {
    margin-right: 8px;
  }
`;

const ButtonsHolder = styled.div`
  display: flex;
  gap: 10px;
`;

const StyledButton = styled(Button)`
  font-size: 11px;
  padding: 0;
  flex: 1;
`;

const ChannelsUpdateNotification = () => {
  const [show, setShow] = useState(true);

  const { teamId } = useParams();

  const navigate = useNavigate();

  const teams = useSelector((state: RootState) => state.teams);

  const teamIds = Object.keys(teams).filter((id) => !isNaN(Number(id)));

  const setCookie = () => {
    const expiryDate = new Date();
    expiryDate.setMonth(expiryDate.getMonth() + 1);

    document.cookie =
      "channelsAlertsBiscuit4331531=1;expires=" + expiryDate + ";path=/";
  };

  const navigateToSettings = () => {
    if (!!teamId && teamId !== "all") {
      return navigate(`/teams/${teamId}/settings`, {
        state: { activeTab: Tabs.CompanyChannels },
      });
    }
    if (teamIds[0]) {
      return navigate(`/teams/${teamIds[0]}/settings`, {
        state: { activeTab: Tabs.CompanyChannels },
      });
    }
  };

  return (
    <>
      {show && (
        <Box>
          <Heading $type="caption">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="8" cy="8" r="8" fill="#4136CF" />
              <path
                d="M7.25 10.2647V11.5H8.75V10.2647H7.25ZM7.25 4.5V9.44118H8.75V4.5H7.25Z"
                fill="white"
              />
            </svg>
            Channels Update
          </Heading>
          <Content $type="smallMedium">
            Please note, Bored Panda channels and Competitors channels have not
            been updated a while. To ensure the accuracy of data, please update
            the channels information in settings.
          </Content>
          <ButtonsHolder>
            <StyledButton
              small
              color="secondary"
              onClick={() => {
                setShow(false);
                setCookie();
              }}
            >
              Remind Later
            </StyledButton>
            <StyledButton
              small
              color="inverted"
              disabled={!teamIds.length}
              onClick={() => {
                setCookie();
                navigateToSettings();
              }}
            >
              Go to Settings
            </StyledButton>
          </ButtonsHolder>
        </Box>
      )}
    </>
  );
};

export default ChannelsUpdateNotification;
